"use client"
import React, { useEffect, useState, useRef } from "react";
import api from "utils/__api__/address";
import { NavBarWrapper, InnerContainer } from "./styles";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckIcon from "@mui/icons-material/Check";
import Cookies from "js-cookie";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";

export default function Navbar({
  elevation = 2,
  border = 0,
  categories,
  navigation,
  isAuth
}) {
  const [addressList, setAddressList] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [searching, setSearching] = useState(false);

  const dropdownRef = useRef(null);

  const fetchAddresses = async () => {
    try {
      setSearching(true)

      const data = await api.getAddressList(1);
      setAddressList(data.addressList.data);
      if (data.addressList.length > 0 && selectedAddress != '') {
        setSelectedAddress(data.addressList.data[0].address);
      }
      setSearching(false)

    } catch (err) {
      setSearching(false)

    }
  };


  useEffect(() => {

    if (isAuth)
      fetchAddresses();
    let address = Cookies.get("address", '');
    setSelectedAddress(address)

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (address, latitude, longitude) => {
    setSelectedAddress(address);
    setIsOpen(false);
    Cookies.remove("user_coords");
    Cookies.set("user_coords", `${latitude},${longitude}`);
    Cookies.set("address", address);
    window.location.reload();

  };

  return (
    <NavBarWrapper elevation={elevation} border={border}>
      <InnerContainer centered={!categories}>
        {categories && isAuth && (
          <Box ref={dropdownRef} sx={{ position: "relative", width: 240 }}>
            {/* Trigger button */}
            <Box
              onClick={() => {
                if (!isOpen) fetchAddresses();
                setIsOpen(!isOpen);
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1.5,
                py: 0.75,
                borderRadius: 2,
                cursor: "pointer",
                border: "1px solid",
                borderColor: isOpen ? "rgb(23, 19, 85)" : "grey.300",
                bgcolor: isOpen ? "rgba(23,19,85,0.04)" : "white",
                transition: "all 0.15s ease",
                "&:hover": {
                  borderColor: "rgb(23, 19, 85)",
                  bgcolor: "rgba(23,19,85,0.04)",
                },
              }}
            >
              <LocationOnIcon sx={{ fontSize: 18, color: "rgb(23, 19, 85)", flexShrink: 0 }} />
              <Box flex={1} minWidth={0}>
                <Typography variant="caption" sx={{ color: "grey.500", display: "block", lineHeight: 1, mb: 0.25 }}>
                  Lugar de entrega
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={600}
                  noWrap
                  sx={{ color: "grey.800", lineHeight: 1.2 }}
                  title={selectedAddress}
                >
                  {selectedAddress || "Seleccionar dirección"}
                </Typography>
              </Box>
              <KeyboardArrowDownIcon
                sx={{
                  fontSize: 18,
                  color: "grey.500",
                  flexShrink: 0,
                  transition: "transform 0.2s",
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
            </Box>

            {/* Dropdown */}
            {isOpen && (
              <Paper
                elevation={4}
                sx={{
                  position: "absolute",
                  top: "calc(100% + 6px)",
                  left: 0,
                  right: 0,
                  zIndex: 1000,
                  borderRadius: 2,
                  overflow: "hidden",
                  border: "1px solid",
                  borderColor: "grey.200",
                  maxHeight: 260,
                  overflowY: "auto",
                }}
              >
                {searching ? (
                  <Box display="flex" justifyContent="center" alignItems="center" py={3}>
                    <CircularProgress size={24} sx={{ color: "rgb(23, 19, 85)" }} />
                  </Box>
                ) : addressList.length === 0 ? (
                  <Box px={2} py={2.5} textAlign="center">
                    <Typography variant="body2" color="text.secondary">
                      No tienes direcciones guardadas
                    </Typography>
                  </Box>
                ) : (
                  addressList.map((item) => {
                    const isSelected = selectedAddress === item.name;
                    return (
                      <Box
                        key={item.id}
                        onClick={() => handleSelect(item.name, item.longitude, item.latitude)}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 1.5,
                          px: 2,
                          py: 1.5,
                          cursor: "pointer",
                          bgcolor: isSelected ? "rgba(23,19,85,0.06)" : "transparent",
                          borderBottom: "1px solid",
                          borderColor: "grey.100",
                          "&:last-child": { borderBottom: "none" },
                          "&:hover": { bgcolor: isSelected ? "rgba(23,19,85,0.08)" : "grey.50" },
                          transition: "background 0.15s",
                        }}
                      >
                        <LocationOnIcon sx={{ fontSize: 16, mt: 0.25, color: isSelected ? "rgb(23, 19, 85)" : "grey.400", flexShrink: 0 }} />
                        <Box flex={1} minWidth={0}>
                          <Typography variant="body2" fontWeight={700} sx={{ color: isSelected ? "rgb(23, 19, 85)" : "grey.800" }} noWrap>
                            {item.name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" noWrap display="block">
                            {item.address}
                          </Typography>
                        </Box>
                        {isSelected && <CheckIcon sx={{ fontSize: 16, color: "rgb(23, 19, 85)", mt: 0.25, flexShrink: 0 }} />}
                      </Box>
                    );
                  })
                )}
              </Paper>
            )}
          </Box>
        )}
        {navigation}
      </InnerContainer>
    </NavBarWrapper>
  );
}
